import React, { useContext, useState } from "react";
import '../../css/templates.css';
import FastEdit from './fastEdit';
import AddTemplate from './addTemplate';
import DetailedEdit from './detailedEdit';
import { deleteTemplate } from '../../utilities/templateFunctions.js';
import { useSelector, useDispatch } from 'react-redux';
import { removeText } from '../../features/textSlice';
import Icon from "../../assets/icons/icon.js";
import { AgentContext } from "../../context/AgentContext.js";


function TextTemplates({ data,formatDate, fetchPage }) {
    const dispatch = useDispatch();
    const agentInfo=useSelector((state) => state.agent.userData);
    const agentId=useSelector((state) => state.agent.userData).agentId;
    const textsFromState = useSelector((state) => state.texts.texts);
    const [editingTemplate, setEditTemplate] = useState(false);
    const [addScript, setAddScript] = useState(false);
    const [transition, setTransition] = useState(false);
    const [editingItemId, setEditingItemId] = useState(null);
    const [newTemplate, setNewTemplate] = useState(null);
    
    // Filter data to exclude templates that have been deleted from Redux state
    // Maintain the same structure: [{type: false}] or [filteredArray]
    const filteredData = (() => {
        if (data[0]?.type === false) {
            return data;
        }
        if (Array.isArray(data[0])) {
            const filtered = data[0].filter(item => textsFromState.some(text => text.id === item.id));
            // If filtered array is empty, return the empty state structure
            return filtered.length === 0 ? [{type: false}] : [filtered];
        }
        return data;
    })();

    const addAScript = () => {
        setAddScript(!addScript);
    };
    const editTemplate = (id,name,content, subject) => {
        if(id===false){
            setEditTemplate(false);
        }
        else{
            setEditTemplate({id:id,name:name,content:content, subject:subject});
        }
    };

    const {isB2B} = useContext(AgentContext)
    const colorData = useSelector(state => state.colorData)

    const handleDeleteTemplate = async (templateId) => {
        const result = await deleteTemplate("Text", templateId, agentId);
        
        dispatch(removeText({ id: templateId }));
        // Trigger refetch to update the UI
        if(fetchPage) {
            await fetchPage('Text_Templates', false);
        }

    };
   
    return (
        <div className={`${isB2B ? 'b2b ' : ''}outerWrapper`}>
                <span className="outerWrapperTitle">
                    <span className="outerWrapperIcon">

                    </span>
                    Templates
                </span>
                <div
                    className="mainBlockOuterWrapper"
                    style={{ justifyContent: "space-around" }}
                >
            {editingTemplate ? (
                <DetailedEdit editTemplate={editTemplate} type='Text' editingTemplate={editingTemplate}/>
            ) : (
                null
            )}

            {addScript ? (
               <AddTemplate addATemplate={addAScript} setNewTemplate={setNewTemplate} type={'Text'}/>

            ):(
            null
            )}
            <div className={`frontPageQuilityParentBlockWrapper ${addScript ? 'closeMainBlock' : editingTemplate ? 'closeMainBlock' : ''}`} style={{width:'75%'}}>
                        <div className="quilityParentBlockHeader">
                            <div className="quilityParentBlockTitle">Text Messages</div>
                        </div>
                        <div className="quilityParentBlockContent">
                            {newTemplate == null ? '' : (
                                <div className={`quilityNestedBlockWrapper ${editingItemId === newTemplate.id ? 'focusBigBlock' : ''}`} key={'temp'} style={{marginTop: '25px'}}>
                                    <div className="quilityCloseWindow" style={{top: '0px'}}><span className="fontello" style={{marginTop: '-7px'}} onClick={()=>handleDeleteTemplate(newTemplate.id)}><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" /></span></div>
                                    <div className="quilityNestedBlockHeader">
                                        <div className="quilityParentBlockTitle">
                                            {newTemplate.name}
                                        </div>
                                    </div>
                                    <div className="infoWrapper">
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Text Name: </span>
                                            {newTemplate.name}
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Content: </span>
                                            <FastEdit
                                                item={newTemplate}
                                                index={'temp'}
                                                transition={transition}
                                                setTransition={setTransition}
                                                editingItemId={editingItemId}
                                                setEditingItemId={setEditingItemId}
                                                type={'Text'}
                                                name={newTemplate.name}
                                                editTemplate={editTemplate}
                                            />
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Date Created: </span>
                                            Just Now
                                        </div>
                                    </div>
                                </div>
                            )}
                            {filteredData[0]?.type !== false && filteredData[0].map((item, index) => (    
                                <div className={`quilityNestedBlockWrapper ${editingItemId === item.id ? 'focusBigBlock' : ''}`} key={`textTemplate-${item.id}`} style={{marginTop: '25px'}}>
                                   <div className="quilityCloseWindow" style={{top: '0px'}}><span className="fontello" style={{marginTop: '-7px'}} onClick={()=>handleDeleteTemplate(item.id)}><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" /></span></div>
                                    <div className="quilityNestedBlockHeader">
                                        <div className="quilityParentBlockTitle">
                                            {item.name}
                                        </div>
                                    </div>
                                    <div className="infoWrapper">
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Text Name: </span>
                                            {item.name}
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Content: </span>
                                            <FastEdit
                                                item={item}
                                                index={index}
                                                transition={transition}
                                                setTransition={setTransition}
                                                editingItemId={editingItemId}
                                                setEditingItemId={setEditingItemId}
                                                type={'Text'}
                                                name={item.name}
                                                editTemplate={editTemplate}
                                            />
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Date Created: </span>
                                            {formatDate(item.created)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {filteredData[0]?.type === false && newTemplate != null < 1 && (
                                <div className="title">You have no templates</div>
                            )}
                        </div>
                        <div className="blockFooter">
                            <div
                                className="buttonWrapper"
                                style={{ marginTop: " 5px", marginLeft: "10px" }}
                            >
                                <div className="dataButtonBlock">Texts: {filteredData[0]?.length ? filteredData[0].length : 0}</div>
                                <div className="actionButtonBlock">
                                    <div className={`accentButton ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={()=>addAScript()}>
                                    +  New Text
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
        </div>

    );
}

export default TextTemplates;

